<template>
  <div class="result text-center">
    <v-row no-gutters class="justify-center">
      <v-col cols="6" md="4" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text class="textboard">
            <div>Sticks Thrown</div>
            <p class="display-1 text--primary">{{ animated_total_throw }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
      <v-col cols="6" md="4" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text class="textboard">
            <div>Sticks Crossed</div>
            <p class="display-1 text--primary">{{ animated_total_cross }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="4" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text class="textboard">
            <p class="pitext display-1 text--primary"><katex-element expression="\\\pi\approx"/> {{ est_pi }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
    
  </div>
</template>
<style  scoped>
.board {
  padding-left: 10px!important;
  padding-right: 10px!important;
  padding-bottom: 10px!important;
}
.v-card[class*="elevation-"]:before {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
}
.v-card.elevation-2:before {
  background: rgba(255, 255, 255, 0.02)
}
.v-card.elevation-5:before {
  background: rgba(255, 255, 255, 0.05)
}
.textboard{
  height: 100px;
}
.pitext{
  position: relative;
  top:calc(50% - 2.5vh);
  font-size: 4vh!important;
}



</style>
<script>
  import {db} from '../plugins/firebase'; 
  import { gsap } from "gsap";

  export default {
    inject: ["eventHub"],
    name: "Result",
    data: () => ({
      total_throw:0,
      total_cross:0,
      temp_total_throw: 0,
      temp_total_cross: 0,
      result:{},
      factor:10/10.4
    }),
    computed: {
    // a computed getter
      est_pi: function () {
        if(this.total_cross == 0){
          return '？'
        }else{
          return Math.round(2*this.total_throw.toFixed(0)/this.total_cross.toFixed(0)*this.factor*10000000)/10000000
        }
      },
      animated_total_throw:function(){
        return this.total_throw.toFixed(0);
      },
      animated_total_cross:function(){
        return this.total_cross.toFixed(0);
      }
    },
    created() {
      db.collection('data').doc('form').collection('global').onSnapshot((snapshot) => {
            this.temp_total_throw = 0;
            this.temp_total_cross = 0;
            var tmpres = this.result;
            snapshot.docChanges().forEach((change) => {
              var doc = change.doc;
                if (doc.data().throw>0 && doc.data().cross>0) {
                    this.result[doc.id]={
                      throw:doc.data().throw,
                      cross:doc.data().cross
                    }
                }
            });
            for (var key in tmpres){     
                var element = tmpres[key];
                this.temp_total_throw += element.throw;
                this.temp_total_cross += element.cross;    
            }

          setTimeout(()=>{ 
            gsap.to(this.$data, { duration: 0.5, total_throw: this.temp_total_throw ,total_cross:this.temp_total_cross});
            // console.log(this.markers)
            this.eventHub.$emit('firestore',{ result:this.result })
          }, 800);
           
      })
    },
  }
</script>